import { useQuery } from "@tanstack/react-query";
import { getProspectingStats } from "@/app/actions/prospect-search/stats/action";
import { ProspectingStats } from "@/app/types/prospect/ProspectingStats";
import { Globals } from "@/app/vars/Globals";
import { QueryKey } from "@/app/vars/QueryKeys";

export function useFetchProspectingStats(options: {
  avatarId?: number;
  enabled?: boolean;
  refetchOnWindowFocus?: boolean;
}) {
  const { avatarId, enabled = true, refetchOnWindowFocus = true } = options;

  return useQuery({
    queryKey: [QueryKey.PROSPECTING_STATS, avatarId],
    queryFn: () => getProspectingStats(avatarId!),
    enabled: enabled && !!avatarId,
    staleTime: Globals.PROSPECT_FRESHNESS_STALE_TIME_MS,
    refetchOnWindowFocus,
    refetchInterval: (query) => {
      const stats = query.state.data as ProspectingStats | undefined;
      return stats?.linkedinPending ? Globals.PROSPECT_JOB_POLLING_INTERVAL_MS : false;
    },
  });
}
